<template>

  <div class="main">

    <div id="top">

      <!-- <div @click="close()"><img src="../../img/Frame@2x.png" alt=""> </div>
      <div class="title">待付款</div> -->

    </div>


    <div id="contemt1">
      <div class="contemt1-img"><img :src="orderInfo.portrait" alt=""></div>
      <div class="contemt1-span">
        <span class="contemt1-span1">{{orderInfo.nickName}}</span>
        <span class="contemt1-span2">「请求你的帮助，是时候该你仗义疏财啦，快帮我付个款吧～」</span>
      </div>
    </div>

    <div id="contemt2">
      <div class="contemt2-span1">
        <span class="contemt2-span1-1">待付金额</span>
        <span class="contemt2-span1-2">{{orderInfo.orderName}}</span>
      </div>

          
        <img class="contemt2-span3" src="../../img/Slice 37@2x-success.png" alt="">
     


      <div class="contemt2-span2">
        <span class="contemt2-span2-1">&nbsp;</span>
        <span class="contemt2-span2-2">¥ {{orderInfo.payMoney}}</span>
      </div>




    </div>

    <!-- <div id="contemt3">
     <div class="contemt3-span1">
        <span class="contemt3-span1-1">选择支付方式</span>
      </div>
      <div class="contemt3-span2">
            <img  class="contemt3-span2-1" src="../../img/wechatpay@2x.png" alt="">
            <span class="contemt3-span2-2" >微信支付</span>
            <img class="contemt3-span2-3" src="../../img/chat_choice_select_default@2x.png" alt="">
      </div>

      <div class="contemt3-span3">
            <img  class="contemt3-span3-1" src="../../img/alipay@2x.png" alt="">
            <span class="contemt3-span3-2" >支付宝支付</span>
            <img class="contemt3-span3-3" src="../../img/chat_choice_select_press@2x.png" alt="">
      </div>


    </div>

    <div id="contemt4">
      确认支付
    </div>


    <div id="contemt5">
      温馨提示：付款前务必和发起者再次确认，避免诈骗行为
    </div> -->


  </div>

</template>

<script>
  import api from "../../api/api";
  import request from '../../api/request';
  export default {
    name: 'successPay',
    components: {

    },
    data() {
      return {
        prizeIndex: undefined,
        orderInfo: {},
        orderNo: '',
      }
    },
    created() {
      document.title='已付款';
      this.orderInfo = JSON.parse( this.$route.query.orderInfo)
      //console.log(this.orderInfo);
      // let orderNo = this.$route.query.orderNo
      // this.orderNo = orderNo
      // console.log(orderNo);
      // this.getOrderInfo();
    },
    computed: {

    },
    mounted() {


    },

    destroyed() {

    },
    methods: {
close(){
 //window.open("about:blank","_self")
window.close();
},
      getOrderInfo() {
        let that = this;

        request.getWay(
          "http://apitest.haiouchat.com/api/sys/waitPay/" + that.orderNo, null,
          function (response) {
            that.orderInfo = response.data

          }
        );



      },
    }
  }

</script>

<style scoped>
  .main {
    margin: 0px;
    padding: 0px;
    width: 375px;
    height: 768px;


    /* background: url(../img/bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%; */

    display: flex;
    flex-direction: column;
    align-items: center;

    background: #F7F7F8;
    border-radius: 0px 0px 0px 0px;
  }

  #top {
    width: 375px;
    height: 44px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    background: #F7F7F8;

    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 21px;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }


  .title {
    margin-left: 124px;
  }

  #top>div>img {
    width: 17px;
    height: 17px;
    opacity: 1;
    margin-left: 20px;

  }

  #contemt1 {
    width: 343px;
    height: 100px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-top: 12px;

    display: flex;
    flex-direction: row;

    justify-content: flex-start;
    align-items: center;


  }

  .contemt1-img>img {
    width: 48px;
    height: 48px;
    opacity: 1;
    border-radius: 24px 24px 24px 24px;
    margin-left: 16px;
  }

  .contemt1-span {
    height: 100px;
    display: flex;
    flex-direction: column;

    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 16px;
    margin-left: 8px;
  }

  .contemt1-span1 {

    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 16px;

    margin-top: 16px;

  }

  .contemt1-span2 {

    width: 246px;
    height: 40px;
    text-align: initial;
    margin-top: 8px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;

  }


  #contemt2 {
    width: 343px;
    height: 90px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-top: 12px;

    display: flex;
    flex-direction: row;

    justify-content: space-between;
    align-items: center;

  text-align: left;
  }


  .contemt2-span1 {
    height: 90px;
    display: flex;
    flex-direction: column;

    justify-content: flex-start;
    align-items: flex-start;
  }


    .contemt2-span1-1 {

font-size: 14px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
line-height: 16px;

    margin-top: 12px;
    margin-left: 16px;

  }

    .contemt2-span1-2 {
font-size: 14px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #333333;
line-height: 16px;

    margin-top: 19px;
    margin-left: 16px;

  }



  .contemt2-span2 {
    height: 90px;
    width: 180px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;

  
  }



    .contemt2-span2-1 {

font-size: 12px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #333333;
line-height: 14px;

    margin-top: 12px;
    margin-right: 16px;

  }

    .contemt2-span2-2 {
font-size: 24px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #EB4D3D;
line-height: 28px;

    margin-top: 15px;
    margin-right: 28px;

  }


  .contemt2-span3 {
width: 48px;
height: 36px;
opacity: 1;
position: absolute;
left:152px;
top: 168px;
  
  }


  #contemt3 {
    width: 343px;
    height: 160px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-top: 12px;

        display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

  }

    .contemt3-span1 {
font-size: 14px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 16px;

    margin-top: 12px;
    margin-left: 16px;

  }


    .contemt3-span2 {
      height: 28px;
        display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 24px;

  }


    .contemt3-span2-1 {
width: 28px;
height: 28px;
 margin-left: 16px;

  }

    .contemt3-span2-2 {
font-size: 14px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 16px;
 margin-left: 8px;

  }


      .contemt3-span2-3 {
width: 16px;
height: 16px;
opacity: 1;
margin-left: 203px;

  }

    .contemt3-span3 {
    height: 28px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 24px;

  }


    .contemt3-span3-1 {
width: 28px;
height: 28px;
 margin-left: 16px;

  }

    .contemt3-span3-2 {
font-size: 14px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 16px;
 margin-left: 8px;

  }


      .contemt3-span3-3 {
width: 16px;
height: 16px;
opacity: 1;
margin-left: 189px;

  }


  #contemt4 {
    width: 343px;
    height: 44px;
    background: #4371FF;
    border-radius: 40px 40px 40px 40px;
    opacity: 1;

    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 16px;


    margin-top: 24px;

            display: flex;
    flex-direction: row;
    justify-content: center ;
    align-items: center;

  }

#contemt5 {
  width: 343px;
  font-size: 12px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
line-height: 14px;

margin-top: 24px;
text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/successPay/index.vue